import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { API } from "@/lib/api";
import { Logo } from "@/components/Logo";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { ShoppingCart, Check } from "lucide-react";

export default function SharedGiftList() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState(false);
  const [name, setName] = useState(() => localStorage.getItem("omy_guest_name") || "");

  const load = () => fetch(`${API}/gifts/shared/${token}`)
    .then((r) => { if (!r.ok) throw new Error("nf"); return r.json(); })
    .then(setData).catch(() => setErr(true));
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [token]);

  const reserve = async (id, on) => {
    if (!name.trim()) return;
    localStorage.setItem("omy_guest_name", name.trim());
    await fetch(`${API}/gifts/shared/${token}/${on ? "reserve" : "unreserve"}`, {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ item_id: id, name: name.trim() }),
    });
    load();
  };

  if (err) return <div className="min-h-screen flex items-center justify-center text-muted-foreground px-6 text-center">Lien de liste invalide ou expiré.</div>;
  if (!data) return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Chargement…</div>;
  const { list, items } = data;

  return (
    <div className="min-h-screen omy-grain">
      <div className="max-w-2xl mx-auto px-5 py-10">
        <div className="flex items-center justify-between mb-8"><Logo /><span className="text-xs text-muted-foreground">Liste partagée</span></div>
        <span className="font-mono text-[10px] uppercase tracking-widest text-primary">Liste de cadeaux{list.occasion ? ` · ${list.occasion}` : ""}</span>
        <h1 className="font-display text-3xl font-semibold mt-1">{list.title}</h1>
        {list.recipient && <p className="text-muted-foreground mt-1">Pour {list.recipient}</p>}

        <div className="mt-5 mb-6">
          <label className="text-xs text-muted-foreground">Votre prénom (pour réserver sans doublon)</label>
          <Input data-testid="guest-name" value={name} onChange={(e) => setName(e.target.value)} placeholder="Ex. Camille" className="mt-1 bg-black/30 max-w-xs" />
        </div>

        <div className="space-y-2">
          {items.map((it) => {
            const reserved = it.status === "reserved" || it.status === "bought";
            const mine = it.reserved_by && name.trim() && it.reserved_by === name.trim();
            return (
              <div key={it.id} data-testid={`shared-item-${it.id}`} className="omy-glass rounded-2xl p-4 flex items-center gap-3">
                <div className="flex-1 min-w-0">
                  <p className={`text-sm font-medium truncate ${reserved && !mine ? "line-through text-muted-foreground" : ""}`}>{it.name}</p>
                  <p className="text-xs text-muted-foreground truncate">{[it.store, it.price != null ? `${it.price} €` : null, reserved ? `Réservé par ${it.reserved_by}` : null].filter(Boolean).join(" · ") || "—"}</p>
                </div>
                {it.url && <a href={it.url} target="_blank" rel="noreferrer" className="text-xs text-primary hover:underline inline-flex items-center gap-1 shrink-0"><ShoppingCart size={13} /> Voir</a>}
                {!reserved && <Button data-testid={`reserve-${it.id}`} size="sm" disabled={!name.trim()} onClick={() => reserve(it.id, true)} className="bg-primary hover:bg-primary/90 rounded-full shrink-0">Réserver</Button>}
                {reserved && mine && <Button data-testid={`unreserve-${it.id}`} size="sm" variant="outline" onClick={() => reserve(it.id, false)} className="rounded-full shrink-0">Annuler</Button>}
                {reserved && !mine && <span className="text-xs text-emerald-400 inline-flex items-center gap-1 shrink-0"><Check size={13} /> Pris</span>}
              </div>
            );
          })}
        </div>
        <p className="text-xs text-muted-foreground mt-8 text-center">Propulsé par OMY — votre mémoire du quotidien.</p>
      </div>
    </div>
  );
}
